@if (executionHistory) {
  <div>
    <div class="hblock">
      <span class="orderHistoryText">Order ID: <span>{{executionHistory.veoOrderID}}</span>
      <span class="orderIdText">From Rebal ID:</span>
      <span>{{rebalanceIDDisplayValue}}</span>
      @if (executionHistory.priorOrderId) {
        <span  class="orderIdText">Prior Order ID:</span>
        <span>
          &nbsp;<a (click)="showPriorOrder($event)">{{executionHistory?.priorOrderId}}</a>
          &nbsp;-&nbsp;<span>{{formatOrderStatus(executionHistory?.priorOrderStatus)}}</span>
        </span>
      }
    </span>
  </div>
  <div class="hblock">
    <div class="left">
      Symbol:	{{data.securitySymbol}}
    </div>
    <div class="left executedQTYText">
      Executed Qty:	{{executionHistory.executedQuantity}}
    </div><br class="clear"/>
  </div>
  <div class="block">
    <div class="left">
      Avg Price:	{{executionHistory.averagePrice}}
    </div>
    <div class="left executedTimeText">
      Last Execution Time:{{executionHistory.lastExecutionTime }}
    </div><br class="clear"/>
  </div>
</div>
}

@if (!isUiTest) {
  <irb-inventory-grid
    [style.minHeight]="'300px'"
    [gridHeight]="'300px'"
    [showSideBar]="false"
    [gridOptions]="gridOptions"
    [columnDefs]="gridOptions.columnDefs"
    [rowData]="orderStatusHistory">
  ></irb-inventory-grid>
}
